// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1xEmm","loaderOuter":"PageOverlayLoader_loaderOuter__rAg9-"};